import { useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { buSlugParam, dateParam, personalSlugParam } from "routes/constants";

export const useGetEntityParams = () => {
  const params = useParams();
  const [entityParams, setEntityParams] =
    useState<Array<{ key: string; value: string }>>();

  useLayoutEffect(() => {
    setEntityParams(() => {
      const tmpEntityParams = [];

      if (params?.[buSlugParam]) {
        tmpEntityParams.push({
          key: buSlugParam,
          value: params?.[buSlugParam] || "",
        });
      }

      if (params?.[personalSlugParam]) {
        tmpEntityParams.push({
          key: personalSlugParam,
          value: params?.[personalSlugParam] || "",
        });
      }

      if (params?.[dateParam]) {
        tmpEntityParams.push({
          key: dateParam,
          value: params?.[dateParam] || "",
        });
      }

      return tmpEntityParams;
    });
  }, [params]);

  return entityParams;
};
